import React from "react";
import {
    List,
    Datagrid,
    Edit,
    Create,
    TextField,
    EditButton,
    TextInput,
    Filter,
} from "react-admin";
import BaseForm from "../baseForm";

const form = <BaseForm fields={{name: '', name_vi: '', order: 0}} images={{thumbnail: ''}}/>

const InnerSoundCategoryFilter = (props) => (
    <Filter {...props}>
        <TextInput source="name" label="name" alwaysOn/>
    </Filter>
);

export const InnerSoundCategoryList = props => (
    <List {...props} filters={<InnerSoundCategoryFilter/>} filter={{is_published: true}}>
        <Datagrid>
            <TextField source="id"/>
            <TextField source="name"/>
            <TextField source="name_vi"/>
            <TextField source="order"/>
            <EditButton basePath="/inner-sound-category"/>
        </Datagrid>
    </List>
);

export const InnerSoundCategoryEdit = props => (
    <Edit {...props}>
        {form}
    </Edit>
);

export const InnerSoundCategoryCreate = props => (
    <Create title="Create a category" {...props}>
        {form}
    </Create>
);
